import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/** Type d'une feuille d'heures (enum App\Entity\TimeSheetType de l'API, GET /time_sheet_types) : Normale, Absence */
export default class TimeSheetTypeModel extends AbstractApiModel {
  protected _path = '/time_sheet_types/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:time_sheet_type:${this.id}`);
  }
}
